// App.js
// Root component for our application
import React from 'react'
import { ColumnParent, Column, ColumnDivider } from 'components/layout';
import RetirementCalculator from 'modules/retirement-calculator/retirement-calculator'
import {MioLogo} from 'components/mio-logo'

class Base extends React.Component {
  constructor(props){
    super(props)
  }

  render(){
    return (
      <div className="Base">      
        <div className="Base__header">
          <ColumnParent align="edges">
            <MioLogo className="MioLogo"/>
            <Column>
              <p className="Base__header__title">Retirement Calculator</p>
            </Column>
          </ColumnParent>
        </div>

        <div className="RcBase__content">
          <RetirementCalculator />
        </div>
      </div>
    )
  }
}

export default Base
     


// WEBPACK FOOTER //
// ./components/base/base.js